import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { FiTaskV2ReportComponent } from './fi-task-v2-report/fi-task-v2-report/fi-task-v2-report.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiTaskV2ReportWidgetDetailsComponent } from './fi-task-v2-report/fi-task-v2-report-widget-details/fi-task-v2-report-widget-details.component';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { FiTaskV2ReportDataService } from './fi-task-v2-report/services/fi-task-v2-report-data.service';
import { ITask2ReportContainer } from './fi-task-v2-report/fi-task-v2-report';
import { FiTaskV2ReportService } from './fi-task-v2-report/services/fi-task-v2-report.service';

const TaskV2ReportState: Ng2StateDeclaration = {
    name: FiStateNames.TaskV2.Report._name,
    url: '/Report',
    abstract: true,
    component: FiAbstractStateComponent,
    onExit: (tr: Transition, state: Ng2StateDeclaration) => {
        const injector = tr.injector();
        const fiTaskV2ReportDataService: FiTaskV2ReportDataService = injector.get(FiTaskV2ReportDataService);
        fiTaskV2ReportDataService.resetReportContainer();
    },
};

const TaskV2ReportDashboardState: Ng2StateDeclaration = {
    name: FiStateNames.TaskV2.Report.Dashboard,
    url: '/Dashboard',
    params: {
        reloadData: null,
        taskId: null,
        scheduleId: null,
        reportType: null,
        timePeriodType: null,
        startDate: null,
        endDate: null,
        /*taskId: 121, // for opening given report view from start
        scheduleId: 236,
        reportType: FiTask2ReportType.PastTasks,
        timePeriodType: FiTask2ReportTimePeriodType.LastWeek,
        startDate: '2025-05-28T21:00:00.000Z',
        endDate: '2025-06-01T21:00:00.000Z',*/
    },
    component: FiTaskV2ReportComponent,
    reloadOnSearch: false,
    resolve: {},
};

const TaskV2ReportWidgetState: Ng2StateDeclaration = {
    name: FiStateNames.TaskV2.Report.Widget,
    url: '/{id:[0-9]+}?:sortColumn&:sortDirection&:offset',
    views: {
        '@Module': {
            component: FiTaskV2ReportWidgetDetailsComponent,
        },
    },
    reloadOnSearch: false,
    params: {
        isFilterExpanded: false,
        reportsCount: 0,
    },
    resolve: {
        reportContainer: [
            FiTaskV2ReportDataService,
            (fiTaskV2ReportDataService) => fiTaskV2ReportDataService.getReportContainer(),
        ],
        widget: [
            'reportContainer',
            FiStateService,
            Transition,
            (reportContainer: ITask2ReportContainer, fiStateService: FiStateService, tr: Transition) => {
                const widgetId = coerceNumberProperty(fiStateService.getParams(tr).id);
                return reportContainer.ReportWidgets.find((widget) => widget.Id === widgetId);
            },
        ],
        availableItems: ['reportContainer', (reportContainer: ITask2ReportContainer) => reportContainer.AvailableItems],
        isFilterExpanded: [
            FiStateService,
            Transition,
            (fiStateService: FiStateService, tr: Transition) => {
                return fiStateService.getParams(tr).isFilterExpanded;
            },
        ],
        reportsCount: [
            FiTaskV2ReportService,
            (fiTaskV2ReportService: FiTaskV2ReportService) => fiTaskV2ReportService.getReportCount(),
        ],
    },
};

export const TaskV2ReportStates: StatesModule = {
    states: [TaskV2ReportState, TaskV2ReportDashboardState, TaskV2ReportWidgetState],
};

export function registerTaskV2ReportStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.TaskV2.Report._name], {
        SettingType: [ApplicationSettingsType.TaskV2Reports],
        AccessType: AccessRightType.Read,
    });
    stateAccessCheckService.registerStateRules([FiStateNames.TaskV2.Report.Dashboard], {
        SettingType: [ApplicationSettingsType.TaskV2Reports],
        AccessType: AccessRightType.Read,
    });
}
